import { Action } from '@ngrx/store';
import { Vehicle } from '@quorum/models/xs-resource';

export enum VehiclesEntityActionTypes {
  GetVehicleFromServer = '[Vehicle] Get Vehicle From Server',
  GetVehicleFromServerError = '[Vehicle] Get Vehicle From Server Error',
  GetVehicleFromServerSuccess = '[Vehicle] Get Vehicle From Server Success',
  UpdateVehicleOnServer = '[Vehicle] Update Vehicle On Server',
  UpdateVehicleOnServerError = '[Vehicle] Update Vehicle On Server Error',
  UpdateVehicleOnServerSuccess = '[Vehicle] Update Vehicle On Server Success',
  CreateVehicleOnServer = '[Vehicle] Create Vehicle From Server',
  CreateVehicleOnServerError = '[Vehicle] Create Vehicle From Server Error',
  CreateVehicleOnServerSuccess = '[Vehicle] Create Vehicle From Server Success',
}

//#region message-types
export class GetVehicleFromServer implements Action {
  readonly type = VehiclesEntityActionTypes.GetVehicleFromServer;
  constructor(public payload: { params: { id: number } }) {}
}
export class GetVehicleFromServerError implements Action {
  readonly type = VehiclesEntityActionTypes.GetVehicleFromServerError;
  constructor(public payload: any) {}
}
export class GetVehicleFromServerSuccess implements Action {
  readonly type = VehiclesEntityActionTypes.GetVehicleFromServerSuccess;
  constructor(public payload: Vehicle[]) {}
}

export class UpdateVehicleOnServer implements Action {
  readonly type = VehiclesEntityActionTypes.UpdateVehicleOnServer;
  constructor(public payload: Vehicle) {}
}
export class UpdateVehicleOnServerError implements Action {
  readonly type = VehiclesEntityActionTypes.UpdateVehicleOnServerError;
  constructor(public payload: any) {}
}
export class UpdateVehicleOnServerSuccess implements Action {
  readonly type = VehiclesEntityActionTypes.UpdateVehicleOnServerSuccess;
  constructor(public payload: Vehicle) {}
}

export class CreateVehicleOnServer implements Action {
  readonly type = VehiclesEntityActionTypes.CreateVehicleOnServer;
  constructor(public payload: Vehicle) {}
}
export class CreateVehicleOnServerError implements Action {
  readonly type = VehiclesEntityActionTypes.CreateVehicleOnServerError;
  constructor(public payload: any) {}
}
export class CreateVehicleOnServerSuccess implements Action {
  readonly type = VehiclesEntityActionTypes.CreateVehicleOnServerSuccess;
  constructor(public payload: Vehicle) {}
}
//#endregion

export type VehiclesEntityAction =
  | GetVehicleFromServer
  | GetVehicleFromServerError
  | GetVehicleFromServerSuccess
  | UpdateVehicleOnServer
  | UpdateVehicleOnServerError
  | UpdateVehicleOnServerSuccess
  | CreateVehicleOnServer
  | CreateVehicleOnServerError
  | CreateVehicleOnServerSuccess;

export const fromVehiclesEntityActions = {
  GetVehicleFromServer,
  GetVehicleFromServerError,
  GetVehicleFromServerSuccess,
  UpdateVehicleOnServer,
  UpdateVehicleOnServerError,
  UpdateVehicleOnServerSuccess,
  CreateVehicleOnServer,
  CreateVehicleOnServerError,
  CreateVehicleOnServerSuccess,
};
